import { useEffect, useState } from 'react'

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(IS_CLIENT_SIDE ? window.matchMedia(query).matches : false)

  useEffect(() => {
    const mql = window.matchMedia(query)
    setMatches(mql.matches)

    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    try {
      mql.addEventListener('change', onChange)
    } catch (err) {
      mql.addListener(onChange)
    }

    return () => {
      try {
        mql.removeEventListener('change', onChange)
      } catch (err) {
        mql.removeListener(onChange)
      }
    }
  }, [query])

  return matches
}
